export const LIVE_VIDEO_SETTINGS_LIST_QUERY_KEY = 'liveVideoSettingsList';
export const LIVE_VIDEO_SETTINGS_QUERY_KEY = 'liveVideoSettings';
export const LIVE_VIDEO_TIMES_QUERY_KEY = 'liveVideoTimes';
export const VIDEO_AUTH_QUERY_KEY = 'videoAuth';
